import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfUsePage = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-br from-[#FFF4E6] to-[#FAFAF8]">
        <div className="container-custom">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-serif font-bold text-[#1A1A1A] mb-4">
              Terms of Use
            </h1>
            <p className="text-[#6B7280]">
              Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            
            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">Acceptance of Terms</h2>
              <p className="text-[#6B7280] leading-relaxed mb-4">
                By accessing and using this website, you accept and agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use this website.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">Informational Purpose</h2>
              <p className="text-[#6B7280] leading-relaxed mb-4">
                The content on this website is provided for general informational purposes only. It is not intended to constitute professional advice, and should not be relied upon as such. The information presented may not reflect the most current developments or apply to your specific situation.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">No Guarantee of Outcomes</h2>
              <p className="text-[#6B7280] leading-relaxed mb-4">
                TekClap makes no guarantees regarding outcomes, results, or performance unless explicitly defined in a written agreement between TekClap and the client. Any examples, case studies, or testimonials presented on this website are for illustrative purposes only and do not guarantee similar results.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">Intellectual Property</h2>
              <p className="text-[#6B7280] leading-relaxed mb-4">
                All content on this website, including but not limited to text, graphics, logos, images, and software, is the property of TekClap or its content suppliers and is protected by United States and international intellectual property laws. You may not reproduce, distribute, modify, or create derivative works from any content without prior written consent from TekClap.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">User Conduct</h2>
              <p className="text-[#6B7280] leading-relaxed mb-4">When using this website, you agree not to:</p>
              <ul className="list-disc pl-6 text-[#6B7280] space-y-2">
                <li>Violate any applicable laws or regulations</li>
                <li>Infringe upon the rights of others</li>
                <li>Attempt to gain unauthorized access to any portion of the website</li>
                <li>Interfere with the proper functioning of the website</li>
                <li>Use the website for any fraudulent or malicious purpose</li>
              </ul>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">Limitation of Liability</h2>
              <p className="text-[#6B7280] leading-relaxed mb-4">
                To the fullest extent permitted by law, TekClap shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses resulting from your access to or use of this website.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">Third-Party Links</h2>
              <p className="text-[#6B7280] leading-relaxed mb-4">
                This website may contain links to third-party websites. TekClap is not responsible for the content, privacy practices, or terms of use of any third-party websites. We encourage you to review the policies of any third-party sites you visit.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">Governing Law</h2>
              <p className="text-[#6B7280] leading-relaxed mb-4">
                These Terms of Use shall be governed by and construed in accordance with the laws of the United States. Any disputes arising under or in connection with these terms shall be subject to the exclusive jurisdiction of the courts located within the United States.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">Changes to Terms</h2>
              <p className="text-[#6B7280] leading-relaxed mb-4">
                TekClap reserves the right to modify these Terms of Use at any time. Changes will be effective immediately upon posting to this website. Your continued use of the website following the posting of changes constitutes your acceptance of such changes.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-serif font-semibold text-[#1A1A1A] mb-4">Contact</h2>
              <p className="text-[#6B7280] leading-relaxed">
                If you have any questions about these Terms of Use, please contact us at{' '}
                <a href="mailto:info@tekclap.com" className="text-[#F58B23] hover:underline">info@tekclap.com</a>.
              </p>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfUsePage;
